export default {
	'log-watch': {
		id: 'log-watch',
		label: '生产日志',
		code: '0010_0008'
	}
}
